/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// document.addEventListener('product:added', function(event) {
//   let elem = document.getElementById('cart-upsell-carousel');
//   console.log("elem =" + elem);
//  let myNewStuff = document.querySelector('.single-item');
//   console.log("myNewStuff =" + myNewStuff);
//   elem.innerHTML = elem.innerHTML + myNewStuff;
 
// });

$(document).on("click", '[data-action="add-upsell-to-cart"]', function(e) {    
  e.preventDefault();

  let upsellProductId = $(this).data('variant-id');
  let upsellProductQuantity = $(this).data('variant-quantity');

  addItemToCart(upsellProductId, 1);    // paste your id product number
});

function addItemToCart(variant_id, qty) {
  data = {
    "id": variant_id,
    "quantity": qty
  }

  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: function() { 
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true  //this code is for prestige theme, is to refresh the cart
      }));
    }
  });
  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
    bubbles: true    // same code for prestige theme   
  }));
}